// extracted by mini-css-extract-plugin
export default {"data":"FPPOB","data-row":"YZXzu","value-wrapper":"fo6rT","value":"cnUVh","info-icon":"yvxO4"};